import { Injectable } from '@angular/core';
import {ApiService} from '../../../../core/service/api.service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class VnaCampaignPbxConfigService {

    constructor(private api: ApiService) { }

    getPbxConfigs(pkCamp: number): Observable<any> {
        return this.api.get('vna/campaign/' + pkCamp + '/pbx-configs');
    }

    postPbxConfig(pkCamp: number, formData: FormData, isClone?: boolean): Observable<any> {
        let url = 'vna/campaign/' + pkCamp + '/pbx-config';
        if(isClone){
            url = url + '?is_clone=1';
        }

        return this.api.post(url, formData);
    }

    putPbxConfig(pkCamp: number, pkConfig: number, formData: FormData): Observable<any> {
        return this.api.post('vna/campaign/' + pkCamp + '/pbx-config/' + pkConfig, formData)
    }

    removePbxConfig(pkCamp: number, pkConfig: number): Observable<any> {
        return this.api.customRemove('vna/campaign/' + pkCamp + '/pbx-config/' + pkConfig);
    }
}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna-campaign/services/vna-campaign-pbx-config.service.ts